import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import NewClient from "../Items/NewClient";
import moment from "moment/moment";
import { formatNumber, isNumeric } from "../../helpers/formater";
import useAuthHelper from "../../helpers/AuthHelper";
import { use } from "react";

const NewFactureAchat = (props) => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [isService, setIsService] = useState(false);

  // date de facture
  const currentYear = new Date().getFullYear();
  const firstDayOfYear = `${currentYear}-01-01`;
  const lastDayOfYear = `${currentYear}-12-31`;

  //get form data
  const date_now = new Date();
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [invoiceCreateDate, setInvoiceCreateDate] = useState("");
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
  const remarque = useRef("");
  const [selectedTaxe, setSelectedTaxe] = useState([]);
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState("");
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [numeroDeLaFacture, setNumeroDeLaFacture] = useState(0);
  const fileAtta = useRef();
  const [invoiceStatusCreatedAt, setInvoiceStatusCreatedAt] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [payedAmount, setPayedAmount] = useState(0);
  const [productsDataNoTransformation, setProductsDataNoTransformation] =
    useState([]);
  const [rate, setRate] = useState(0);
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [effetId, setEffetId] = useState("");
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const errorMessage = "Merci de remplir les champs obligatoire !";

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //edit invoice structure wx
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);
  const [totalTTc, setTotalTTC] = useState();

  // sous compte comptable des paiement
  const [sousCompte, setSousCompte] = useState("");
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);

  const [productDetails, setProductDetails] = useState(""); // Added state for product details

  const emptyInputs = () => {
    setSingleSelectedProduct([]);
    setSelectedProduct([]);
    setQty(0);
    setUnitPrice("");
    setTva(0);
    setTotalHt("");
    setTotalTTC("");
    setIsService(false);
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };

  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchSousAccountsCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [depotsProduct, setDepotsProduct] = useState([]);
  const [selectedDepotId, setSelectedDepotId] = useState(0);
  const getProductData = async (selectedProduct) => {
    //selectedProduct
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        //setSingleSelectedProduct(transformProductsArray(response.data.data))
        setUnitPrice(response.data.data[0]["costPrice"]);
        if (selectedProduct?.isService) {
          setIsService(true);
          setQty(1);
        } else {
          setQty(0);
        }
        console.log(
          "response.data.dataresponse.data.dataresponse.data.data: ",
          response.data.data,
        );
        setSelectedProductQty(response.data.data.qty);
        setTva(response.data.data[0]["taxe_achat"].rate);
        setDepotsProduct(response.data.data[0].depot);
      })
      .catch((error) => console.log("error " + error));
  };
  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const addNewProductToInvoice = async () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0 ||
      // selectedDepotId === 0
       (!isService && selectedDepotId === 0)
    ) {
      toast.warn("Tous les champs sont obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
        toast.error("Le produit déja exist !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        hideOffcanvas();
        let product = {
          product_id: singleSelectedProduct.value,
          name: `${singleSelectedProduct.label}  ${productDetails !== "" ? "-" + productDetails : ""}`, // Concatenate product name with details
          isService: singleSelectedProduct.isService,
          compte_de_charge: singleSelectedProduct.compte_de_charge,
          code: singleSelectedProduct.code,
          qty: qty,
          unitPrice: unitPrice,
          tva: tva,
          totalHt: leTotalHt.current.value,
          totalTtc: leTotalTTc.current.value,
          details:
            productDetails === "" || productDetails === null
              ? ""
              : productDetails, // Save product details
          // depot_id: selectedDepotId, // Save selected depot ID
          depot_id: isService ? null : selectedDepotId,
        };
        setInvoiceProductsState([...invoiceProductsState, product]);
        setProductDetails(""); // Reset details field
      }
    }
  };
  const editSingleInvoiceProduct = () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0 ||
      // selectedDepotId === 0
      (!isService && selectedDepotId === 0)
    ) {
      toast.error("Tous les champs sont obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].unitPrice = unitPrice;
          invoiceProductsState[i].totalHt = leTotalHt.current.value;
          invoiceProductsState[i].totalTtc = leTotalTTc.current.value;
          invoiceProductsState[i].depot_id = selectedDepotId; // Update depot ID
          invoiceProductsState[i].details = productDetails;
        }
        setInvoiceProductsState([...invoiceProductsState]);
      }
    }
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        console.log("spliced");
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
  };

  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);
    let product = invoiceProductsState.filter((p) => p.product_id == productId);
    setIsService(product[0].type === "Services");
    setQty(product[0]["qty"]);
    setUnitPrice(product[0]["unitPrice"]);
    setTva(product[0]["tva"]);
    setSelectedDepotId(product[0]["depot_id"]); // Set selected depot ID
    setProductDetails(product[0]["details"]); // Set product details
  };

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures-achat/${organisation?.id}`,
    );
    if (resp.status == 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };

  const { onlyCommercial, hadAddAccess } = useAuthHelper();

  useEffect(() => {
    onlyCommercial();
    hadAddAccess();
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getIncrementedInvoiceNumber();
    $(".some-fields-are-required-to-save").css("display", "none");
    getSuppliers();
    getProducts();
    getPurchaseAccount();
    fetchTaxes();
    getInvoiceStatus();
    getAccounts();
    getNbsInvoices();
    fetchSousAccounts();
    fetchSousAccountsCs();
  }, []);

  useEffect(() => {
    calcInvoiceSummary(invoiceProductsState);
  }, [invoiceProductsState]);
  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };
  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error),
      );
  };
  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const transformArrayToOptions4products = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        isService: target[i]?.type === "Marchandise" ? false : true,
        value: target[i].id,
        label: target[i].name,
        rate: target[i].taxe_achat.rate,
        compte_de_charge: target[i].purchase_account.name,
        code: target[i].purchase_account.code,
      };
      array.push(obj);
    }
    return array;
  };

  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = { value: target[i].id, label: target[i].companyName };
      array.push(obj);
    }
    return array;
  };

  const transformFournisseurArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].companyName + " - " + target[i].account.code,
      };
      array.push(obj);
    }
    return array;
  };

  const getSuppliers = async () => {
    const response = await axios
      .get(
        baseURL +
          `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`,
      )
      .then((response) => {
        setSuppliers(transformFournisseurArrayToOptions(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };
  const onFileUpload = (event) => {
    if (event.target?.files[0]) {
      console.log("event.target.files[0] : " + event.target.files[0]);
      setSelectedAttachment(event.target.files[0]);
    } else {
      console.log("else");
    }
  };
  const getProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        console.log(
          "productsproductsproductsproductsproducts: ",
          response.data.data,
        );
        setProducts(transformArrayToOptions4products(response.data.data));
        setProductsDataNoTransformation(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };
  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/salesaccounts")
      .then((response) => {
        setPurchaseAccounts(transformArrayToOptions(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error),
      );
  };
  const fetchTaxes = async () => {
    const response = await jwtInterceoptor.get(
      `/data/organisation_taxes/${organisation.id}`,
    );

    if (response.status === 200) {
      let result = response.data.data.filter(
        (tx) =>
          tx.tax_type === "fournisseur" &&
          (tx.is_default_tax === 1 || tx.organisation_id === organisation.id),
      );
      setTaxes(transformArrayToOptions(result));
    }
  };
  const getIncrementedInvoiceNumber = async () => {
    let value = 0;
    const response = await jwtInterceoptor
      .get("/data/user/factures_achat/last/" + organisation.id)
      .then((res) => {
        if (res.data.data !== null) {
          console.log("getIncrementedInvoiceNumber: ", res.data.data.id);
          setNumeroDeLaFacture(res.data.data.id + 1);
        } else {
          setNumeroDeLaFacture(1);
        }
      })
      .catch((error) => console.log("error while save", error));
  };
  const save = async (event) => {
    event.preventDefault();
    let isOkToSave = true;
    isOkToSave = !(
      invoiceProductsState.length === 0 ||
      selectedStatus === "" ||
      selectedStatus === 0 ||
      invoiceDueDate.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      selectedSupplier.value === undefined ||
      unitPrice.length === 0 ||
      (autoIncrementInvoiceNumber === false && invoiceNumber === "")
    );

    //etat= payé
    if (
      selectedStatus === "2" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }
    if (
      selectedStatus === "2" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType === caisseAccountId.toString()) {
        isOkToSave = true;
      } else {
        if (banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    //etat = payé en partie
    if (
      selectedStatus === "3" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType !== bqAccountId && payedAmount === 0) {
        isOkToSave = false;
      } else {
        if (paymentType === bqAccountId && banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToSave = false;
    }

    if (invoiceNumber.length > 0) {
      isOkToSave = !numExist;
    }

    if (isOkToSave) {
      let preparedProducts = [];
      let is_custom_invoice_number = 0;
      let numeroDeFacture = "";

      //facture achat products
      for (let i = 0; i < invoiceProductsState.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht: invoiceProductsState[i].unitPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].totalHt,
          total_ttc: invoiceProductsState[i].totalTtc,
          tva: invoiceProductsState[i].tva,
          reference: ref,
          details: invoiceProductsState[i].details, // Add product details here
          depot_id: invoiceProductsState[i].depot_id, // Add depot ID here
        };
        preparedProducts.push(obj);
      }

      console.log("obj: ", preparedProducts);

      if (autoIncrementInvoiceNumber === false) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-ACHAT-${formatNumber(invoiceNumber)}`
          : `FACT-ACHAT-${invoiceNumber}`;
      } else {
        numeroDeFacture = `FACT-ACHAT-${nbInvoices + 1}`;
      }

      let formData = new FormData();
      formData.append("user_id", user.id);
      formData.append("organisation_id", organisation.id);
      formData.append("supplier_id", selectedSupplier.value);
      formData.append("date", invoiceCreateDate);
      formData.append("price_ut", unitPrice);
      formData.append("due_date", invoiceDueDate);
      formData.append("invoice_number", numeroDeFacture);
      formData.append("is_custom_invoice_number", is_custom_invoice_number);
      formData.append("attachment_file", selectedAttachment);
      formData.append("status", selectedStatus);
      formData.append("payed_amount", Number(payedAmount).toFixed(2));

      if (paymentType === bqAccountId.toString()) {
        formData.append("payment_method", sousCompte === "" ? 0 : sousCompte);
        formData.append("payment_account", sousCompte);
      } else if (paymentType === caisseAccountId.toString()) {
        formData.append(
          "payment_method",
          sousCompteCs === "" ? 0 : sousCompteCs,
        );
        formData.append("payment_account", sousCompteCs);
      } else {
        formData.append("payment_method", paymentType === "" ? 0 : paymentType);
        formData.append("payment_account", paymentType);
      }

      if (paymentType === bqAccountId.toString()) {
        formData.append("banquePaymentOption", banquePaymentOption);
        if (banquePaymentOption == "effet") {
          formData.append("effetId", effetId);
          console.log("effet", effetId);
        } else {
          formData.append("chequeId", chequeId);
        }
      } else {
        formData.append("banquePaymentOption", "");
        formData.append("chequeId", "");
        formData.append("effetId", "");
      }

      formData.append("invoice_created_at", invoiceCreatedAt);
      formData.append("payed_invoice_created_at", invoiceStatusCreatedAt);

      formData.append("total", summaryTotatlHt);
      formData.append("total_tva", summaryTotalTva);
      formData.append("total_ttc", summaryTotatlTtc);
      formData.append("products", JSON.stringify(preparedProducts));

      setIsSubmit(true);

      const response = await jwtInterceoptor
        .post("/data/user/factures_achat/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("response: ", res);
          setIsSubmit(false);
          Swal.fire(
            t("La facture d'achat a été créée avec succès."),
            t(""),
            "success",
          );
          navigate("/achat/factureachat/list");
        })
        .catch((error) => {
          setIsSubmit(false);
          console.log("error while save", error);
        });
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };

  const onSaveClient = () => {
    getSuppliers();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le fournisseur a été ajouter avec succès"), t(""), "success");
  };

  const handleInvoiceStatusCreatedAtChange = (e) => {
    const selectedDate = e.target.value;
    setInvoiceStatusCreatedAt(selectedDate);

    if (!invoiceDueDate) {
      toast.error("La date d'échéance n'est pas encore fixée !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setInvoiceStatusCreatedAt("");
      return;
    }

    const createdAtDate = new Date(selectedDate);
    const dueDate = new Date(invoiceDueDate);

    if (createdAtDate < dueDate) {
      toast.warn(
        "la date de paiement que vous avez choisie est antérieure à la date d'échéance, Veuillez vérifier la date ou confirmer cette opération",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="main-container container-fluid">
        <GoBack route={"/achat/factureachat/list"} />

        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">Facture d'achat</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/achat/factureachat/list")}
                >
                  Liste des facture d'achat
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Ajouter une facture d'achat
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong></strong>Attention ! Les champs suivants sont
                  obligatoire.
                </span>
                <p>
                  - L'état de la factrue <br />
                  - Mode de réglement <br />
                  - le produit associé <br />
                  - le fournisseur concérner <br />
                  - Le compte de dépenses,taxe,quantité et prix unitaire <br />
                </p>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <br />
              <div
                class="modal fade"
                id="newClientModal"
                tabIndex="-1"
                aria-labelledby="newClientModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="newClientModal">
                        Ajouter un nouveaux fournisseur
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <NewClient
                        clientType={"fournisseurs"}
                        from={"new_fv"}
                        handleSave={onSaveClient}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h4>{t("Espace Fournisseur")}</h4>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Choisir le fournisseur*
                    </label>
                    <Select
                      options={suppliers}
                      onChange={(choice) => setSelectedSupplier(choice)}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Nouveau fournisseur
                    </label>
                    <a
                      className="btn btn-primary form-control"
                      data-bs-toggle="modal"
                      data-bs-target="#newClientModal"
                    >
                      <i className="fe fe-user"></i> ajouter un fournisseur
                    </a>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h4>Informations sur la facture</h4>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      N° de la facture * (
                      {t(
                        "ce numéro servira de référence pour votre facture originale",
                      )}
                      )
                    </label>
                    <input
                      type="text"
                      placeholder="Fac-achat-0001"
                      className={`form-control `}
                      onChange={(e) => {
                        setInvoiceNumber(e.target.value);
                        let numExist = invoicesNums.findIndex(
                          (c) =>
                            e.target.value == c?.invoice_number ||
                            e.target.value ==
                              (c.is_custom_invoice_number == 1
                                ? c.invoice_number
                                : `Fact-achat-${formatNumber(
                                    c?.invoice_number,
                                  )}`),
                        );
                        if (numExist != -1) {
                          setExitNum(true);
                        } else {
                          setExitNum(false);
                        }
                      }}
                      value={invoiceNumber}
                      id={"invoiceNumberInput"}
                    />
                    {!autoIncrementInvoiceNumber && numExist ? (
                      <span className={"text-danger"}>
                        {t("Ce numéro de facture existe déjà")}
                      </span>
                    ) : null}
                    <label className="custom-control custom-checkbox-md">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="example-checkbox5"
                        value="option5"
                        checked={autoIncrementInvoiceNumber}
                        onClick={() =>
                          setAutoIncrementInvoiceNumber(
                            !autoIncrementInvoiceNumber,
                          )
                        }
                        onChange={(e) => {
                          handleAutoIncrementInvoiceNumber();
                        }}
                      />
                      <span class="custom-control-label">
                        Utiliser le numéro de facture auto-incrementer
                      </span>
                    </label>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date de facture*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date d'échéance*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceDueDate(e.target.value)}
                      value={invoiceDueDate}
                      min={firstDayOfYear}
                    />
                  </div>
                </div>
              </div>

              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">DÉTAILS DE L’ARTICLE</th>
                    <th scope="col">COMPTE DE CHARGE DE L'ARTICLE</th>
                    <th scope="col">QUANTITÉ</th>
                    <th scope="col">PU HT</th>
                    <th scope="col">TVA %</th>
                    <th scope="col">Total HT</th>
                    <th scope="col">Total TTC</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {invoiceProductsState.map((product) => {
                  return (
                    <tr key={product.product_id}>
                      <td>{product.name}</td>
                      <td>{product.compte_de_charge + " - " + product.code}</td>
                      <td>{product.qty}</td>
                      <td>{product.unitPrice}</td>
                      <td>{product.tva + "%"}</td>
                      <td>{product.totalHt}</td>
                      <td>{product.totalTtc}</td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleProduct(product.product_id)
                          }
                          className="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() => {
                            setIsService(product.isService);
                            editSingleProduct(product.product_id);
                            setSelectedDepotId(product.depot_id); // Set selected depot ID for editing
                          }}
                          className="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  ajouter un article
                </button>
              </center>

              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}></div>
                <div className={"col-md-6 d-flex flex-row-reverse"}>
                  <div className="row">
                    <div className="invoiceSummary">
                      <table>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total HT :</td>
                          <td>
                            {Number(summaryTotatlHt).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TVA :</td>
                          <td>
                            {" "}
                            {Number(summaryTotalTva).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TTC :</td>
                          <td>
                            {" "}
                            {Number(summaryTotatlTtc).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Etat*
                    </label>
                    <select
                      className="form-select form-select-lg"
                      id="buyPriceAccountInput"
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      value={selectedStatus}
                    >
                      <option value="0">
                        sélectionner l'état de la facture
                      </option>
                      {invoiceStatus.map((status) => {
                        return <option value={status.id}>{status.name}</option>;
                      })}
                    </select>
                  </div>
                  <div
                    className="paymentSection"
                    style={{
                      display:
                        selectedStatus === "2" || selectedStatus === "3"
                          ? "block"
                          : "none",
                    }}
                  >
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        Date de règlement*
                      </label>
                      <input
                        type="date"
                        placeholder="nom"
                        className={`form-control `}
                        onChange={handleInvoiceStatusCreatedAtChange}
                        value={invoiceStatusCreatedAt}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        Banque ou Caisse*
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                          console.log("paymùslkdnb;s,:", e.target.value);
                        }}
                        value={paymentType}
                      >
                        <option value="0">
                          selectionner un mode de réglement
                        </option>
                        {banqueAccounts.map((account) => (
                          <option
                            value={account.id}
                            onClick={() => console.log("ffdfdfd")}
                          >
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        display:
                          paymentType === "" + bqAccountId + ""
                            ? "block"
                            : "none",
                      }}
                    >
                      <label htmlFor="sousCompte" className="">
                        Sous Compte*
                      </label>
                      <select
                        className="form-select"
                        id="sousCompte"
                        onChange={(e) => {
                          setSousCompte(e.target.value);
                        }}
                        value={sousCompte}
                      >
                        <option value="0">selectionner un sous compte</option>
                        {sousComptes.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        display:
                          paymentType === "" + caisseAccountId + ""
                            ? "block"
                            : "none",
                      }}
                    >
                      <label htmlFor="sousCompteCs" className="">
                        Sous Compte*
                      </label>
                      <select
                        className="form-select"
                        id="sousCompteCs"
                        onChange={(e) => {
                          setSousCompteCs(e.target.value);
                        }}
                        value={sousCompteCs}
                      >
                        <option value="0">selectionner un sous compte</option>
                        {sousComptesCs.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="banqueOptions">
                      <div
                        className="verementOrChéque"
                        style={{
                          display:
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Mode de Réglement *
                          </label>
                          <select
                            className="form-select"
                            id="buyPriceAccountInput"
                            onChange={(e) =>
                              setBanquePaymentOption(e.target.value)
                            }
                            value={banquePaymentOption}
                          >
                            <option value="0">
                              selectionner un mode de réglement
                            </option>
                            <option value="virement">Virement</option>
                            <option value="chéque">Chéque</option>
                            <option value="carte bancaire">
                              Carte Bancaire
                            </option>
                            <option value="effet">Effet</option>
                            <option value="prélévement">Prélévement</option>
                          </select>
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "chéque" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Identificateur du chéque*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setChequeId(e.target.value)}
                            value={chequeId}
                          />
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "effet" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Identificateur d'effet*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setEffetId(e.target.value)}
                            value={effetId}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{
                        display: selectedStatus === "3" ? "block" : "none",
                      }}
                    >
                      <label htmlFor="exampleInputEmail1" className="">
                        Montant payé*
                      </label>
                      <input
                        type="text"
                        placeholder="objet"
                        className={`form-control `}
                        onChange={(e) => {
                          if (e.target.value >= summaryTotatlTtc) {
                            setPayedAmount(0);
                            toast.error(
                              "le mantant payé remplit est supérieur ou égale le total ttc",
                              {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                              },
                            );
                          } else {
                            setPayedAmount(e.target.value);
                          }
                        }}
                        value={payedAmount}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div class="form-group">
                    <label className="form-label">
                      Glissez ou déplacez la piéce (
                      <span className="text-red">
                        Fichier PDF/Image, taille Max 2 Mo
                      </span>
                      )
                    </label>
                    <input
                      className="form-control form-control-lg"
                      type="file"
                      onChange={onFileUpload}
                      ref={fileAtta}
                    />
                  </div>
                </div>
              </div>

              <br />
              <div className="card-footer">
                <div className="d-flex flex-row-reverse">
                  <button
                    disabled={isSubmit}
                    type="button"
                    className="btn btn-primary"
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <a
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default"
                    style={{ marginRight: 10 }}
                  >
                    Annuler
                  </a>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                    Renseigner le produit à ajouter.
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <div id="all-fields-are-required">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong> Tous les champs sont
                        obligatoire !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="warning-product-already-exists">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong> Le produit déja exist !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="qty-is-higher">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong> L'article choisie est en
                        rupture de stock
                      </span>
                    </div>
                    <br />
                  </div>

                  <form className="needs-validation" noValidate="">
                    <div class="form-row">
                      <div class="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          DÉTAILS DE L’ARTICLE*
                        </label>
                        <Select
                          className={"select-article"}
                          value={singleSelectedProduct}
                          options={products}
                          onChange={(choice) => {
                            setSingleSelectedProduct(choice);
                            getProductData(choice);
                            if (!choice.isService) {
                              setIsService(false);
                            }
                          }}
                        />
                      </div>
                      <div className="col-xl-12 mb-3">
                        {/* {depotsProduct?.length > 0 && ( */}
                        {!isService && depotsProduct?.length > 0 && (<>
                          
                            <label htmlFor="productDepots">
                              {t("Dépôts disponibles")}
                            </label>
                            {depotsProduct?.map((depot, index) => (
                              <div key={index} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id={`depot-${index}`}
                                  value={depot.depot_id}
                                  name="productDepot"
                                  checked={selectedDepotId == depot.depot_id}
                                  onChange={(e) => {
                                    setSelectedDepotId(e.target.value);
                                    setSelectedProductQty(depot.quantity);
                                    console.log("productDepot", e.target.value);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`depot-${index}`}
                                >
                                  {depot.depot.name}
                                </label>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      <div class="col-xl-12 mb-3">
                        <label htmlFor="productDetails">
                          Détails du produit
                        </label>
                        <textarea
                          className="form-control"
                          id="productDetails"
                          rows="2"
                          value={productDetails}
                          onChange={(e) => setProductDetails(e.target.value)}
                        ></textarea>
                      </div>
                      <div className="col-xl-3 mb-3" hidden={isService}>
                        <label htmlFor="validationTooltip02">QUANTITÉ*</label>
                        <input
                          className="form-control"
                          id="validationTooltip02"
                          type="number"
                          required
                          value={qty}
                          onChange={(e) => {
                            // Parse the quantity to a float and handle negative values
                            const inputValue = parseFloat(
                              parseFloat(e.target.value).toFixed(2),
                            );

                            // Vérifie si la valeur saisie est un nombre valide
                            if (isNaN(inputValue) || inputValue < 0) {
                              setQty(""); // Réinitialise la quantité en cas de saisie invalide
                              setTotalHt("0.00");
                              setTotalTTC("0.00");
                              return;
                            }

                            // Vérifie si la quantité dépasse le stock disponible
                            if (inputValue > selectedProductQty) {
                              setQty(inputValue);
                              setTotalHt("0.00");
                              setTotalTTC("0.00");
                              return;
                            }

                            // Calcule les valeurs
                            const totalHtl = (inputValue * unitPrice).toFixed(
                              2,
                            );
                            const totalTTC = (
                              parseFloat(totalHtl) +
                              (parseFloat(totalHtl) * tva) / 100
                            ).toFixed(2);

                            // Met à jour l'état
                            setQty(inputValue);
                            setTotalHt(totalHtl);
                            setTotalTTC(totalTTC);
                          }}
                        />
                      </div>
                      <div class="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">PU HT*</label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          // required=""
                          value={unitPrice}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (!isNaN(value)) {
                              let total_ht = qty * value;
                              let total_ttc = (
                                parseFloat(total_ht) +
                                (parseFloat(total_ht) * tva) / 100
                              ).toFixed(2);
                              setUnitPrice(parseFloat(value.toFixed(2)));
                              setTotalHt(parseFloat(total_ht.toFixed(2)));
                              setTotalTTC(total_ttc);
                            }
                          }}
                          // disabled={!isService}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">Total HT*</label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={isService ? unitPrice.toFixed(2) : totalHt}
                          ref={leTotalHt}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">Total TTC*</label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={
                            isService
                              ? (
                                  parseFloat(unitPrice.toFixed(2)) +
                                  (parseFloat(unitPrice.toFixed(2)) * tva) / 100
                                ).toFixed(2)
                              : totalTTc
                          }
                          ref={leTotalTTc}
                        />
                      </div>
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewProductToInvoice}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSingleInvoiceProduct}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewFactureAchat;
